import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'
import { useCommunity } from 'utils'
import * as Types from 'types'

const propTypes = {
  value: PropTypes.string,
  data: PropTypes.shape({
    organizationId: PropTypes.number.isRequired,
    partnerState: PropTypes.string.isRequired,
    schoolId: PropTypes.number.isRequired,
    schoolYearId: PropTypes.number.isRequired,
    type: PropTypes.oneOf([Types.PARTNER_TYPE, Types.SCHOOL_TYPE]).isRequired,
    organizationBadges: PropTypes.arrayOf(PropTypes.shape(Types.badgeQuestion)),
    schoolBadges: PropTypes.arrayOf(PropTypes.shape(Types.badgeQuestion)),
  }),
}

function PartnerTableLinkCell({
  value,
  data: {
    organizationId,
    partnerState,
    schoolId,
    schoolYearId,
    type,
    organizationBadges,
    schoolBadges,
  },
}) {
  const community = useCommunity()
  const url = type === Types.PARTNER_TYPE ? '/partners' : '/schools'
  const id = type === Types.PARTNER_TYPE ? organizationId : schoolId

  const isContributor =
    (type === Types.PARTNER_TYPE &&
      organizationBadges?.some((b) => b.name === 'org_contributor')) ||
    (type === Types.SCHOOL_TYPE &&
      schoolBadges?.some((b) => b.name === 'school_contributor'))

  return (
    <td className="partner-table-link-cell flex-horizontal flex-gap-1">
      {partnerState === 'approved' &&
      !(type === Types.SCHOOL_TYPE && community?.schoolDisabled) ? (
        <Link
          to={{
            pathname: `${url}/${id}`,
            search: `?year=${schoolYearId}`,
          }}
          data-cy="partner-table-link"
        >
          {value}
        </Link>
      ) : (
        value
      )}
      {isContributor && (
        <div className="contributor-badge">
          artlook<sup>®</sup> Contributor
        </div>
      )}
    </td>
  )
}

PartnerTableLinkCell.propTypes = propTypes

export default PartnerTableLinkCell
